import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectLanguage, toggleLanguage } from '../../store/languageSlice';
import { selectTheme } from '../../store/themeSlice';

const LanguageSwitch = () => {
  const language = useSelector(selectLanguage);
  const theme = useSelector(selectTheme);
  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(toggleLanguage());
  };

  return (
    <button
      onClick={handleToggle}
      className="flex items-center gap-2 px-3 py-2 text-sm font-medium"
      style={{
        color: 'var(--text-secondary)',
        backgroundColor: 'transparent',
        transition: 'all 0.3s ease-out',
        textShadow: 'none',
      }}
      onMouseEnter={(e) => {
        e.target.style.color = 'var(--hover-accent)';
        e.target.style.textShadow = 'var(--hover-text-glow)';
      }}
      onMouseLeave={(e) => {
        e.target.style.color = 'var(--text-secondary)';
        e.target.style.textShadow = 'none';
      }}
      aria-label="Toggle language"
    >
      <svg 
        className="w-4 h-4" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" 
        />
      </svg>
      <span className="font-semibold">{language.toUpperCase()}</span>
    </button>
  );
};

export default LanguageSwitch;
